/* eslint-disable import/prefer-default-export */
export { default as HrElement } from './HrElement';
